module.exports = __webpack_public_path__ + "static/media/ketone-bottom.f071d5eb.png";